// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__iMBoC","content":"GlobalSearch_content__1se8M"};